import * as React from 'react';

import { AddDeductionField } from '../fields/AddDeductionField';

type AddDeductionWidgetProps = {
  onAddDeduction?: (deduction: {
    typeId: string;
    typeName: string;
    amount: number;
    isWeightBased: boolean;
  }) => void;
  buttonSize?: 'sm' | 'md' | 'lg' | 'xl';
};

// ⚛️ ⚛️ ⚛️ ADD DEDUCTION WIDGET ⚛️ ⚛️ ⚛️
export const AddDeductionWidget: React.FC<AddDeductionWidgetProps> = ({
  onAddDeduction,
  buttonSize,
}) => {
  // Callbacks
  const handleAddDeduction = React.useCallback(
    (deduction: {
      typeId: string;
      typeName: string;
      amount: number;
      isWeightBased: boolean;
    }) => {
      onAddDeduction?.(deduction);
    },
    [onAddDeduction],
  );

  return (
    <AddDeductionField
      onAddDeduction={handleAddDeduction}
      className="@AddDeductionWidget"
      buttonSize={buttonSize}
    />
  );
};
